import {
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { FlashyTokenService } from '@flashy/users/data-access';
import { ModalsService } from '@services/modals/modals.service';
import { ToastService } from '@services/toast/toast.service';
import { TopNavService } from '@services/top-nav/top-nav.service';
import { EMPTY, throwError } from 'rxjs';
import { catchError, exhaustMap, finalize, tap } from 'rxjs/operators';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
function isSilent(req: HttpRequest<any>): boolean {
  return req.params.has('silent') || req.body?.silent;
}
let needReAuthentication = false;
export const errorSuccessInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const router = inject(Router);
  const tokenService = inject(FlashyTokenService);
  const toastService = inject(ToastService);
  const topNavService = inject(TopNavService);
  const modalsService = inject(ModalsService);

  topNavService.setLoadingSate(true);
  return next(req).pipe(
    // delay(3000), // Test the loading
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    tap((event: HttpEvent<any>) => {
      if (
        event.type === HttpEventType.Response &&
        event.status === 200 &&
        !req.url.includes('auth') &&
        !isSilent(req) &&
        !req.urlWithParams.includes('?flashy_action=ticket')
      ) {
        if (['PUT', 'DELETE', 'POST'].includes(req.method)) {
          toastService.success($localize`:@@success:Success.`);
        }
      }
    }),
    catchError((error: HttpErrorResponse) => {
      let message = '';
      if (error.status === 500) {
        message = 'Server error';
      } else if (error.status === 400 && !isSilent(req)) {
        toastService.error(Object.values(error.error.errors).join('\n'));
        return EMPTY;
      } else if ([401, 403].includes(error.status)) {
        tokenService.clear();
        // router.navigateByUrl('/auth');
        if (!needReAuthentication) {
          needReAuthentication = true;
          return modalsService.reAuth().pipe(
            exhaustMap(() => {
              needReAuthentication = false;
              if (!router.url.includes('/dash')) {
                router.navigateByUrl('/dash').then();
                return throwError(() => error);
              }
              // Retry the req again after authentication
              return next(
                req.clone({
                  headers: req.headers.set(
                    'Authorization',
                    `Bearer ${tokenService.token}`
                  ),
                })
              );
            })
          );
        }
        return throwError(() => error);
      } else {
        message = error.error?.errors
          ? Object.values(error.error.errors).join('\n')
          : 'Undefined error-success';
      }
      if (message) {
        toastService.error(message);
      }
      return throwError(() => error);
    }),
    finalize(() => topNavService.setLoadingSate(false))
  );
};
